// extracted by mini-css-extract-plugin
export default {"permissionLabel":"CPUPermissions_permissionLabel__OJTo0","permissionGrid":"CPUPermissions_permissionGrid__AxZIs","permissionInput":"CPUPermissions_permissionInput__bX-3m"};